import React from 'react';
import PropTypes from 'prop-types';
import './FloatingAlert.css';

import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

const FloatingAlert = ({ show }) => {
  if (!show) return null;

  return (
    <div
      className="floating-alert"
      title="Scroll to view more"
    >
      <KeyboardDoubleArrowDownIcon className="arrow-icon" />
      <span className="hover-text">Scroll to view more</span>
    </div>
  );
};

FloatingAlert.propTypes = {
  show: PropTypes.bool.isRequired
};

export default FloatingAlert;
